import React from "react";
import { Icon, SecondaryButton } from "@prestosports/commons-ui";
import Printer32 from "@carbon/icons-react/lib/printer/32";
import Printable from "../../common/components/Printable";
import GameStats from "./GameStats";

const TennisPrint = ({ showPreview, setShowPreview, fileName }) => {
	return (
		<>
			<SecondaryButton
				id="button-print-stats"
				onClick={() => setShowPreview(true)}
				label="Print"
				startIcon={
					<Icon>
						<Printer32 />
					</Icon>
				}
			/>
			{showPreview && (
				<Printable
					fileName={fileName}
					showPreview={showPreview}
					onAfterPrint={() => setShowPreview(false)}
				>
					<GameStats print />
				</Printable>
			)}
		</>
	);
};

export default TennisPrint;
